import React from "react";
import { FiMail } from "react-icons/fi";
import { motion } from "framer-motion";

import Footer from "../components/common/Footer";
import ContactDetails from "../components/ContactPage/ContactDetails";
import ContactForm from "../components/ContactPage/ContactForm";
import ReviewSlider from "../components/common/ReviewSlider";
import { DS } from "../utils/designSystem";
import { fadeIn } from "../components/common/motionFrameVarients";

const Contact = () => {
  return (
    <div className="bg-richblack-900">
      {/* ── Page hero ───────────────────────────────────────────── */}
      <section className="relative overflow-hidden border-b border-richblack-700 py-16 md:py-20">
        <div
          aria-hidden
          className="pointer-events-none absolute -top-24 right-0 h-[400px] w-[400px] rounded-full bg-yellow-50/5 blur-3xl"
        />
        <div className={DS.layout.container}>
          <motion.div
            variants={fadeIn("up", 0.05)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="flex flex-col items-center text-center"
          >
            <span className={`${DS.badge.base} ${DS.badge.neutral} mb-4`}>
              <FiMail className="text-sm" />
              We&apos;re here to help
            </span>
            <h1 className={`${DS.text.display} max-w-xl`}>
              Get in{" "}
              <span className={DS.gradient.highlight}>Touch</span>
            </h1>
            <p className={`${DS.text.body} mt-4 max-w-lg`}>
              Have a question about a course, a collaboration idea, or just want
              to say hello? We&apos;d love to hear from you.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ── Main content ────────────────────────────────────────── */}
      <section className={DS.layout.section}>
        <div className={DS.layout.container}>
          <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:gap-12">
            {/* Contact details panel */}
            <motion.div
              variants={fadeIn("right", 0.1)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.1 }}
              className="w-full lg:w-[38%] lg:sticky lg:top-24"
            >
              <ContactDetails />
            </motion.div>

            {/* Contact form panel */}
            <motion.div
              variants={fadeIn("left", 0.1)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.1 }}
              className="w-full lg:flex-1"
            >
              <ContactForm />
            </motion.div>
          </div>
        </div>
      </section>

      {/* ── Reviews ─────────────────────────────────────────────── */}
      <section className="border-t border-richblack-700 py-16">
        <div className={DS.layout.container}>
          <div className={DS.section.header}>
            <h2 className={DS.text.sectionTitle}>What Our Learners Say</h2>
            <div className={DS.section.underline} />
          </div>
          <ReviewSlider />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
